module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-art-1.dc339ccb.jpg";